import { Collections } from "Collections";
import { AnalyticsEvent } from "models/AnalyticsEvent";
import { AppUser, noAppUserNameText } from "models/AppUser";
import { Paths } from "Paths";
import { Avatar, ListItemAvatar } from "@material-ui/core";
import { Person } from "@material-ui/icons";
import React from "react";

import { ListScreen } from "../ListScreen";

const getName = (appUser: AppUser) => noAppUserNameText(appUser.contactInfo?.name?.fullName)

export function AppUsersScreen() {
    return (
        <>
            <ListScreen<AppUser>
                title="App-Brukere"
                collectionName={Collections.APP_USERS}
                noEntriesText="Det er ingen brukere"
                fieldName="appUser"
                path={Paths.APP_USERS}
                standardBackButton
                getName={getName}
                getErrorEvent={AnalyticsEvent.GET_APP_USERS_ERROR}
                getAvatar={(appUser) => {
                    return (
                        <ListItemAvatar>
                            <Avatar src={appUser.avatarImage?.original.url || undefined}>
                                <Person />
                            </Avatar>
                        </ListItemAvatar>
                    )
                }}
                getSecondaryText={appUser => {
                    return appUser.contactInfo?.email?.email
                }}
            />
        </>
    )
}
